import React from 'react';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
} from '../../../../../../../shared/lib/toggleModalVisble';
import AddEntityBtn from '../../../../../../../shared/ui/AddEntityBtn/AddEntityBtn';

const AddEntity = ({ shutdown }) => {
  const dispatch = useModalDispatch();

  const handleClick = (e) => {
    e.stopPropagation();

    dispatch({
      type: modalActionTypes.setModalData,
      payload: {
        type: modalTypes.addShutdownResponsible,
        initialValues: shutdown,
      },
    });
  };

  return (
    <AddEntityBtn
      style={{ marginTop: '8px' }}
      onClick={handleClick}
    />
  );
};

export default AddEntity;
